/**
 * Auth Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.4
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ManagementClientSubscriptionResponse } from './managementClientSubscriptionResponse';
import { ManagementClientTagResponse } from './managementClientTagResponse';
import { ManagementResellerResponse } from './managementResellerResponse';

export interface InternalClientDetailsResponse { 
    id?: string;
    name?: string;
    description?: string;
    taxId?: string;
    showTags?: boolean;
    showSentiment?: boolean;
    lang?: InternalClientDetailsResponse.LangEnum;
    foreignCountry?: boolean;
    lastClippingReportSentAt?: Date;
    lastBiReportSentAt?: Date;
    subscriptions?: Array<ManagementClientSubscriptionResponse>;
    tags?: Array<ManagementClientTagResponse>;
    reseller?: ManagementResellerResponse;
}
export namespace InternalClientDetailsResponse {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}